import React, { FC } from 'react';
import { Tooltip, Icon } from '@beeline.com/bp-design-system';
import { useCustomFieldsAndObjectsIntl } from '../../translations/useCustomFieldsAndObjectsIntl';

interface Props {
  checked: boolean;
  dataTest: string;
}

export const CheckedIcon: FC<React.PropsWithChildren<Props>> = ({ checked, dataTest }) => {
  const intl = useCustomFieldsAndObjectsIntl();
  return checked ? (
    <Tooltip title={intl.true}>
      <Icon dataTest={dataTest} data-value="true" name="check_circle" color="colorSuccess" size="small" />
    </Tooltip>
  ) : (
    <Tooltip title={intl.false}>
      <Icon dataTest={dataTest} data-value="false" name="cancel" color="colorAlert" size="small" />
    </Tooltip>
  );
};
